import { apiFetch } from "./client.js";

/**
 * Assistente pessoal de IA (aba "Automação").
 * A cliente monta a base de conhecimento como BLOCOS livres ({título, conteúdo})
 * que ela cria/edita/remove à vontade — como containers de informação. A IA usa
 * esses blocos para responder contatos que chegam via WhatsApp/Instagram até um
 * humano assumir; quando não sabe, escala. Backend: GET/PUT /ai-assistant/me.
 */

export type KnowledgeBlock = {
  title: string;
  content: string;
};

export type AiAssistant = {
  enabled: boolean;
  escalateOnUnknown: boolean;
  triggerMode: string;
  companyName: string;
  tone: string;
  hours: string;
  knowledgeBlocks: KnowledgeBlock[];
};

export type AiAssistantPatch = Partial<AiAssistant>;

export const DEFAULT_AI_ASSISTANT: AiAssistant = {
  enabled: false,
  escalateOnUnknown: true,
  triggerMode: "until_human",
  companyName: "",
  tone: "",
  hours: "",
  knowledgeBlocks: [],
};

export async function fetchAiAssistant(): Promise<AiAssistant> {
  const data = await apiFetch("/ai-assistant/me");
  return normalize(data);
}

export async function updateAiAssistant(patch: AiAssistantPatch): Promise<AiAssistant> {
  const data = await apiFetch("/ai-assistant/me", {
    method: "PUT",
    body: JSON.stringify(patch),
  });
  return normalize(data);
}

function normalizeBlocks(raw: unknown): KnowledgeBlock[] {
  if (!Array.isArray(raw)) return [];
  const blocks: KnowledgeBlock[] = [];
  for (const item of raw) {
    if (!item || typeof item !== "object") continue;
    const obj = item as Partial<KnowledgeBlock>;
    blocks.push({
      title: typeof obj.title === "string" ? obj.title : "",
      content: typeof obj.content === "string" ? obj.content : "",
    });
  }
  return blocks;
}

function normalize(data: unknown): AiAssistant {
  if (!data || typeof data !== "object") return DEFAULT_AI_ASSISTANT;
  const raw = data as Partial<AiAssistant>;
  return {
    enabled: Boolean(raw.enabled),
    escalateOnUnknown: raw.escalateOnUnknown === undefined ? true : Boolean(raw.escalateOnUnknown),
    triggerMode: typeof raw.triggerMode === "string" && raw.triggerMode ? raw.triggerMode : "until_human",
    companyName: typeof raw.companyName === "string" ? raw.companyName : "",
    tone: typeof raw.tone === "string" ? raw.tone : "",
    hours: typeof raw.hours === "string" ? raw.hours : "",
    knowledgeBlocks: normalizeBlocks(raw.knowledgeBlocks),
  };
}
